import React from 'react'
import { DynamicRoute } from 'lib/shared'
import { ProductScene } from 'scenes/Product'
import { CmsPage } from 'app/sofia/scenes/CmsPage'
import { NoMatch } from 'app/sofia/scenes/NoMatch'
import { CategoryScene } from 'app/sofia/scenes/Category'
import { EntityType, PrismicPageResolver } from 'modules/prismic'

export const EntityResolver = () => {
  return (
    <DynamicRoute
      prismicPageType={[
        EntityType.Page
      ]}
      components={{
        Category: CategoryScene,
        CmsPage,
        Product: ProductScene,
        NoMatch,
        PrismicPage: PrismicPageResolver
      }}
    />
  )
}
